import { all } from 'redux-saga/effects';
import { booksSaga } from './booksStore/sagas';

export function* rootSaga() {
  yield all([booksSaga()]);
}
